// import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import React, { Suspense, lazy } from 'react';

import { lazyRetry } from 'src/js/utils';
import { useAttachsParams } from 'providers/attachs-params';
import { useAttachsState } from 'providers/attachs-state';
import ImageViewer from './ImageViewer';
import InxToolTip from 'containers/Attachments/ToolTip';
import Loader, { CardLoaderWrap } from 'components/Loader';
import Overlay from 'containers/Overlay';

const Card = {
    Calendar: lazy(() => lazyRetry(() => import(
        /* webpackChunkName: "panel_calendar" */
        './CalendarViewer'
    ), 'panel_calendar')),
    Pdf: lazy(() => lazyRetry(() => import(
        /* webpackChunkName: "panel_pdf-viewer" */
        './PdfViewer'
    ), 'panel_pdf-viewer')),
    Player: lazy(() => lazyRetry(() => import(
        /* webpackChunkName: "panel_media-player" */
        './Player'
    ), 'panel_media-player')),
    Zip: lazy(() => lazyRetry(() => import(
        /* webpackChunkName: "panel_zip-viewer" */
        './ZipViewer'
    ), 'panel_zip-viewer'))
};

const PreviewPanels = () => {
    const {
        calendarViewMode, imgViewMode, isPreviewMode, pdfViewMode, playerMode, zipViewMode,
    } = useAttachsState();
    const { tooltipComponentId } = useAttachsParams();

    return (
        <React.Fragment>
            {(isPreviewMode() && !imgViewMode) && (
                <Portal>
                    <Overlay overlayType='dark'>
                        <Suspense fallback={
                            <CardLoaderWrap>
                                <Loader size='lg' />
                            </CardLoaderWrap>
                        }>
                            {calendarViewMode && <Card.Calendar />}
                            {playerMode && <Card.Player />}
                            {pdfViewMode && <Card.Pdf />}
                            {zipViewMode && <Card.Zip />}
                            <InxToolTip id={tooltipComponentId} />
                        </Suspense>
                    </Overlay>
                </Portal>
            )}
            {imgViewMode && <ImageViewer />}
        </React.Fragment>
    );
};

export default PreviewPanels;
